import { Observable, of, throwError } from 'rxjs';
import { delay, mergeMap, retry } from 'rxjs/operators';

import { MSafeAny } from '@app/shared/models/safe-any/safe-any.model';
const getErrorMessage = (maxRetry: number) => `Tried to load Resource over XHR ${maxRetry} times without success`;

const DEFAULT_MAX_RETRIES = 1;

/**
 *
 * @param {number} delayMs Delay in milliseconds before each retry.
 * @param {number} maxRetry Number of retries to make in case of failure. Default is 1.
 */
export function delayedRetry(delayMs: number, maxRetry = DEFAULT_MAX_RETRIES) {
  let retries = maxRetry;

  return (src: Observable<MSafeAny>) =>
    src.pipe(
      retry({
        delay: (errors: Observable<MSafeAny>) =>
          errors.pipe(
            delay(delayMs),
            mergeMap((error) => (retries-- > 0 ? of(error) : throwError(() => getErrorMessage(maxRetry))))
          )
      })
    );
}
